export const stationTypeMap = {
  Open: "Otwarty",
  Closed: "Zamknięty",
};

export const statusTypeMap = {
  OK: { label: "GOTOWY", color: "green" },
  OFFLINE: { label: "OFFLINE", color: "grey" },
  NOK: { label: "BŁĘDY", color: "red" },
  NOT_KNOWN: { label: "NIEZNANY", color: "grey" },
};
